angular
  .module('webtip.module', [
    'ui.router',
    'translations'
  ]);
require('./webtip-main-view/webtip-main-view.component');

